import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { errorToastStyle } from "../customToast";
import moment from "moment";
import InputMask from "react-input-mask";
import styled from "styled-components";
import { Input, CalenderIcon } from ".";
import ZoomLevelProvider from "../container/projectList/ZoomLevelProvider";

export function DatePickerComponent({
  className,
  placeholder,
  disabled,
  isInvalid,
  selected,
  onChange,
  isCompleted,
  originalScheduledStartDate,
  revisedScheduledStartDate,
  originalScheduledFinishDate,
  revisedScheduledFinishDate,
  setZIndex,
  sponsoredByCategory,
  ...rest
}) {
  const [selectedDate, setSelectedDate] = useState(selected || null);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);
  const [isTyping, setIsTyping] = useState(false);
  const [isBackspace, setIsBackspace] = useState(false);
  const [error, setError] = useState(false);
  const [zoomPercentage, setZoomPercentage] = useState("");
  const [isunderscrore, setIsunderscrore] = useState(false);
  const [hasClickedOutsideOnce, setHasClickedOutsideOnce] = useState(false);

  useEffect(() => {
    if (selected !== undefined) {
      setSelectedDate(selected || null);
      setInputValue(selected ? moment(selected).format("DD/MM/YYYY") : "");
    }
  }, [selected]);

  const wrapperRef = useRef(null);
  const hasNumber = value => /\d/.test(value);

  const handleManualInput = event => {
    setIsTyping(true);
    setHasClickedOutsideOnce(false);
    let newValue = event && event.target ? event.target.value.trim() : null;
    dateValidation(newValue);
    // setTimeout(() => {
    //   if (inputRef.current) inputRef.current.focus();
    // }, 0);
  };
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        isTyping &&
        inputValue &&
        !hasClickedOutsideOnce // run only if not already clicked outside
      ) {
        //handleManualInput({ target: { value: inputValue } });

        if (!isBackspace && hasNumber(inputValue) && !error) {
          toast.error(
            <p className="toast-text-alignment">Invalid date</p>,
            errorToastStyle
          );
          setSelectedDate(null);
        }

        setError(true);
        setIsBackspace(false);
        setHasClickedOutsideOnce(true); // prevent future runs
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputValue, isTyping, hasClickedOutsideOnce]);

  const dateValidation = newValue => {
    const MIN_YEAR = 1900;
    const MAX_YEAR = 2100;

    if (!newValue || newValue.includes("_") || newValue.length < 10) {
      setInputValue(newValue);
      setIsBackspace(false);
      setError(false);

      if (isBackspace) {
        toast.error(
          <p className="toast-text-alignment">Invalid date</p>,
          errorToastStyle
        );
      }
      return;
    }

    setInputValue(newValue);

    const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!datePattern.test(newValue)) {
      setError(true);
      toast.error(
        <p className="toast-text-alignment">Invalid date</p>,
        errorToastStyle
      );
      setSelectedDate(null);

      return;
    }

    const [day, month, year] = newValue.split("/").map(Number);
    const daysInMonth = new Date(year, month, 0).getDate();

    if (month < 1 || month > 12 || day < 1 || day > daysInMonth) {
      setError(true);
      toast.error(
        <p className="toast-text-alignment">Invalid date</p>,
        errorToastStyle
      );
      setInputValue(newValue);
      setSelectedDate(null);
      setIsTyping(false);
      return;
    }

    if (month === 2 && day === 29 && !isLeapYear(year)) {
      setError(true);
      toast.error(
        <p className="toast-text-alignment">Invalid date</p>,
        errorToastStyle
      );
      setInputValue(newValue);
      setSelectedDate(null);
      return;
    }

    if (year < MIN_YEAR || year > MAX_YEAR) {
      setError(true);
      toast.error(
        <p className="toast-text-alignment">Invalid date</p>,
        errorToastStyle
      );
      setSelectedDate(null);
      return;
    }

    const parsedDate = new Date(year, month - 1, day);

    // Check date ranges
    if (
      originalScheduledStartDate &&
      new Date(originalScheduledStartDate) > parsedDate
    ) {
      setError(true);
      setIsBackspace(true);
      toast.error(
        <p className="toast-text-alignment">
          Original Finish Date cannot be earlier than the Original Start Date
        </p>,
        errorToastStyle
      );
      return;
    }

    if (
      originalScheduledFinishDate &&
      new Date(originalScheduledFinishDate) < parsedDate
    ) {
      setError(true);
      setIsBackspace(true);
      toast.error(
        <p className="toast-text-alignment">
          Original Start Date cannot be greater than the Original Finish Date
        </p>,
        errorToastStyle
      );
      return;
    }

    if (
      revisedScheduledStartDate &&
      new Date(revisedScheduledStartDate) > parsedDate
    ) {
      setError(true);
      setIsBackspace(true);
      toast.error(
        <p className="toast-text-alignment">
          Revised Finish Date cannot be earlier than the Revised Start Date
        </p>,
        errorToastStyle
      );
      return;
    }

    if (
      revisedScheduledFinishDate &&
      new Date(revisedScheduledFinishDate) < parsedDate
    ) {
      setError(true);
      setIsBackspace(true);
      toast.error(
        <p className="toast-text-alignment">
          Revised Start Date cannot be greater than the Revised Finish Date
        </p>,
        errorToastStyle
      );
      return;
    }

    // ✅ All good
    setSelectedDate(parsedDate);
    setIsTyping(false);
    setError(false); // <- moved here
    if (onChange) onChange(parsedDate);
  };

  const isLeapYear = year =>
    (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

  const handleDateChange = date => {
    console.log("is clicked");
    //setInputValue(moment(date).format("DD/MM/YYYY"));
    if (date) {
      dateValidation(moment(date).format("DD/MM/YYYY"));
    }
  };

  const clearDate = () => {
    setSelectedDate(null);
    setInputValue("");
    if (onChange) onChange(null);
    setTimeout(() => {
      if (inputRef.current) inputRef.current.focus();
    }, 0);
  };

  const handleKeyUp = e => {
    if (e.key === "Backspace" || e.key === "Delete") {
      setIsBackspace(true);
      setIsunderscrore(true);
      setInputValue(""); // Immediately update inputValue
      dateValidation(e.target.value); // Validate the potentially incomplete value
      if (!e.target.value) {
        if (onChange) onChange(null);
      }
    }
  };

  const handleZoomChange = zoom => {
    setZoomPercentage(zoom);
  };
  let displayerrorClass;

  if (className.includes("error-milestone")) {
    displayerrorClass = className;
  } else if (error) {
    displayerrorClass = className + " " + "error-milestone";
  } else {
    displayerrorClass = `custom-datepicker-container ${className || ""}`;
  }

  return (
    <>
      <ZoomLevelProvider onZoomChange={handleZoomChange} />
      <div ref={wrapperRef} className={displayerrorClass}>
        {sponsoredByCategory ? (
          <DatePicker
            isClearable
            disabled={disabled}
            placeholderText={placeholder || "DD/MM/YYYY"}
            showYearDropdown
            showMonthDropdown
            locale="en"
            dateFormat="dd/MM/yyyy"
            selected={selectedDate}
            onChange={handleDateChange}
            onCalendarOpen={() => {
              setZIndex(0);
            }}
            onCalendarClose={() => {
              setZIndex(1);
            }}
            onChangeRaw={e => {
              e.preventDefault(); // Prevent react-datepicker from hijacking raw input
            }}
            //portalId="root-portal"
            //onChangeRaw={handleManualInput}
            className={
              isInvalid ? "date-input-div is-invalid" : "date-input-div"
            }
            shouldCloseOnSelect
            //
            customInput={
              <div key="custom-date-input" className="input-with-icon">
                <InputMask
                  mask="99/99/9999"
                  //maskChar={!isunderscrore ? "" : "_"}
                  //maskChar=""
                  maskChar="_"
                  onKeyUp={handleKeyUp}
                  value={inputValue}
                  placeholder="DD/MM/YYYY"
                  disabled={disabled}
                  onChange={handleManualInput}
                >
                  {inputProps => (
                    <input
                      {...inputProps}
                      ref={inputRef}
                      className="custom-date-input"
                      type="text"
                      disabled={disabled}
                    />
                  )}
                </InputMask>
                <span
                  className="calendar-icon"
                  onClick={() => inputRef.current && inputRef.current.focus()}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "10px",
                    top: "8px"
                  }}
                >
                  <CalenderIcon />
                </span>
              </div>
            }
            portalId="tableID"
            {...rest}
          />
        ) : (
          <DatePicker
            isClearable
            disabled={disabled}
            placeholderText={placeholder || "DD/MM/YYYY"}
            showYearDropdown
            showMonthDropdown
            locale="en"
            dateFormat="dd/MM/yyyy"
            selected={selectedDate}
            onChange={handleDateChange}
            // onCalendarOpen={() => {
            //   setZIndex(0);
            // }}
            // onCalendarClose={() => {
            //   setZIndex(1);
            // }}
            onChangeRaw={e => {
              e.preventDefault(); // Prevent react-datepicker from hijacking raw input
            }}
            //portalId="root-portal"
            //onChangeRaw={handleManualInput}
            className={
              isInvalid ? "date-input-div is-invalid" : "date-input-div"
            }
            shouldCloseOnSelect
            //
            customInput={
              <div key="custom-date-input" className="input-with-icon">
                <InputMask
                  mask="99/99/9999"
                  //maskChar={!isunderscrore ? "" : "_"}
                  //maskChar=""
                  maskChar="_"
                  onKeyUp={handleKeyUp}
                  value={inputValue}
                  placeholder="DD/MM/YYYY"
                  disabled={disabled}
                  onChange={handleManualInput}
                >
                  {inputProps => (
                    <input
                      {...inputProps}
                      ref={inputRef}
                      className="custom-date-input"
                      type="text"
                      disabled={disabled}
                    />
                  )}
                </InputMask>
                <span
                  className="calendar-icon"
                  onClick={() => inputRef.current && inputRef.current.focus()}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "10px",
                    top: "8px"
                  }}
                >
                  <CalenderIcon />
                </span>
              </div>
            }
            portalId="tableID"
            {...rest}
          />
        )}

        {inputValue && !isCompleted && (
          <div
            className="custom-clear-button"
            style={{
              right: zoomPercentage === 90 ? "14px" : "7px",
              marginTop: zoomPercentage === 90 ? "-19px" : null
            }}
            onClick={clearDate}
          >
            <button
              style={{
                background: "none",
                //display: "contents",
                verticalAlign: "middle",
                borderRadius: "50%",
                border: "none",
                color: "aliceblue",
                fontSize: "12px"
              }}
              title="Clear date"
            >
              <span
                style={{ fontSize: "10px", lineHeight: 1, fontFamily: "mpsb" }}
              >
                x
              </span>
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export const DatePickerStyled = styled(DatePickerComponent)`
  .react-datepicker-wrapper {
    display: block;
    cursor: pointer;
    .react-datepicker__input-container {
      display: block;
      cursor: pointer;
    }
    input[type="text"] {
      cursor: pointer;
    }
    .react-datepicker__close-icon {
      right: 39px;
    }
  }
  .react-datepicker__year-option--selected,
  .react-datepicker__month-option--selected,
  .react-datepicker__month-year-option--selected {
    left: 5px;
  }
  .react-datepicker__month-dropdown,
  .react-datepicker__year-dropdown {
    width: 100px;
    position: absolute !important;
    left: 0;
    top: 10px;
  }
  .is-invalid {
    div {
      div {
        z-index: 1;
      }
    }
    fieldset {
      border-color: #fc192e !important;
      background: #fef4f4 !important;
    }
  }

  .calendar-icon {
    position: absolute;
    right: 8px;
    top: 8px;
  }
`;
